var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20215 6.19178V2.72093H4.70215V6.19178H6.20215ZM6.67308 2.25H21.5908V0.75H6.67308V2.25ZM22.0617 2.72093V6.19178H23.5617V2.72093H22.0617ZM21.5908 2.25C21.8509 2.25 22.0617 2.46084 22.0617 2.72093H23.5617C23.5617 1.63241 22.6793 0.75 21.5908 0.75V2.25ZM6.20215 2.72093C6.20215 2.46084 6.41299 2.25 6.67308 2.25V0.75C5.58456 0.75 4.70215 1.63242 4.70215 2.72093H6.20215Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20215 16.9828V20.4536H4.70215V16.9828H6.20215ZM6.67308 20.9246H21.5908V22.4246H6.67308V20.9246ZM22.0617 20.4536V16.9828H23.5617V20.4536H22.0617ZM21.5908 20.9246C21.8509 20.9246 22.0617 20.7137 22.0617 20.4536H23.5617C23.5617 21.5421 22.6793 22.4246 21.5908 22.4246V20.9246ZM6.20215 20.4536C6.20215 20.7137 6.41299 20.9246 6.67308 20.9246V22.4246C5.58456 22.4246 4.70215 21.5421 4.70215 20.4536H6.20215Z",
    fill: "#4A4A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24944 11.7161L7.28711 11.7161",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08789 14.5425L1.24936 11.7162L4.08789 8.8894",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2486 11.7161L21.2109 11.7161",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4102 14.5425L27.2487 11.7162L24.4102 8.8894",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5651 7.09571C15.7347 6.73618 14.9793 6.55642 14.2988 6.55642H14.241C13.4278 6.55642 12.8692 6.70408 12.5653 6.99941C12.3128 7.24337 12.1865 7.67352 12.1865 8.28985V8.31553C12.1865 8.97039 12.3791 9.40696 12.7643 9.62524C13.0254 9.76648 13.492 9.89061 14.1639 9.99761C14.8402 10.1046 15.3431 10.1966 15.6727 10.2737C16.0022 10.3464 16.2826 10.4684 16.5137 10.6396C16.9931 10.9992 17.2328 11.6818 17.2328 12.6876V12.8417C17.2328 14.1771 16.7127 15.0224 15.6727 15.3777C15.3517 15.4847 14.9986 15.5532 14.6133 15.5831V17.3294H13.6503V15.5831C12.5161 15.5146 11.5809 15.26 10.8447 14.8191L11.2685 13.9203C12.24 14.4339 13.1902 14.6907 14.119 14.6907C15.1976 14.6907 15.8289 14.3462 16.0129 13.6571C16.0729 13.4302 16.1028 13.1692 16.1028 12.8738V12.6876C16.1028 12.388 16.0814 12.1462 16.0386 11.9622C15.9958 11.7781 15.9059 11.6283 15.769 11.5128C15.5464 11.3202 15.02 11.1597 14.1896 11.0313C13.4492 10.9157 12.9377 10.8065 12.6552 10.7038C12.3727 10.6011 12.1395 10.4898 11.9554 10.37C11.7756 10.2459 11.6216 10.0918 11.4932 9.90773C11.2278 9.52252 11.0951 9.04529 11.0951 8.47604C11.0951 7.9025 11.1529 7.4531 11.2685 7.12781C11.384 6.80252 11.5509 6.53502 11.7692 6.32529C12.1844 5.9358 12.8114 5.71324 13.6503 5.6576V4.04614H14.6133V5.6576C15.5164 5.69612 16.2783 5.8502 16.8989 6.11985L16.5651 7.09571Z",
    fill: "#4A4A4A",
    stroke: "#4A4A4A",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWire);
export default __webpack_public_path__ + "static/media/wire.93aaa85d2d4eda1d10acec6dac1cb76a.svg";
export { ForwardRef as ReactComponent };